import { render, staticRenderFns } from "./RequestEmailForm.vue?vue&type=template&id=137b2c0c&scoped=true&"
import script from "./RequestEmailForm.vue?vue&type=script&lang=ts&"
export * from "./RequestEmailForm.vue?vue&type=script&lang=ts&"
import style0 from "./RequestEmailForm.vue?vue&type=style&index=0&id=137b2c0c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137b2c0c",
  null
  
)

export default component.exports